export const timeConstants = {
    msInSecond: 1000,
    secInMinute: 60,
    minInHour: 60,
    hoursInDay: 24,
};
export const radixParameter = 10;
